import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects-details',
  templateUrl: './projects-details.component.html',
  styleUrls: ['./projects-details.component.scss']
})
export class ProjectsDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
